import { useAuth } from "#root/components/auth";
import type { ReactNode } from "react";
import { useEffect } from "react";

import PageLayout from "./layout";

export default function LogoutPage(): ReactNode {
  const auth = useAuth();
  useEffect(() => {
    auth?.logout();
  }, [auth]);

  return <PageLayout title="Logout"/>;
}
